import React from 'react';
import { useTheme } from './hooks/useTheme';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PropertyIntro } from './components/PropertyIntro';
import { PhotoGallery } from './components/PhotoGallery';
import { Features } from './components/Features';
import { StandardsCatalog } from './components/StandardsCatalog';
import { LocationSection } from './components/LocationSection';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <div className="w-full min-h-screen bg-villa-bg font-inter text-villa-text transition-colors duration-500" data-id="element-0">
      <Navbar theme={theme} onToggleTheme={toggleTheme} data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PropertyIntro data-id="element-4" />
        <PhotoGallery data-id="element-5" />
        <Features data-id="element-6" />
        <StandardsCatalog data-id="element-7" />
        <LocationSection theme={theme} data-id="element-8" />
        <ContactForm theme={theme} data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}